<template>
	<div>
		<h4>Grupy w sekcji {{section.name}}</h4>
		<ol>
			<li v-for="(group, index) in section.groups" v-bind:key="index" :class="isSelected(index)">
				{{ group.name }}
				<v-icon @click="openRenameModal(index)" flat>
					create
				</v-icon>
				<v-icon @click="moveGroupUp(index)" flat v-if="groupCanBeMovedUp(group, index)">
					arrow_upward
				</v-icon>
				<v-icon @click="moveGroupDown(index)" flat v-if="groupCanBeMovedDown(group, index)">
					arrow_downward
				</v-icon>
				<v-icon @click="selectGroup(index)">build</v-icon>
				<v-icon @click="removeGroup(index)" flat v-if="groupCanBeRemoved(group)">
					close
				</v-icon>

				<span v-if="!groupIsNotFinal(group)">FINAL</span>
				<span v-if="groupContainsConditionalField(group)">CONDITIONAL</span>
			</li>
		</ol>
		<EditNameModal ref="editNameModal" v-on:rename="renameGroup"/>
	</div>
</template>
<script>
	import {fieldTypes} from "../../../../../utils/FieldTypes";
	import EditNameModal from "../EditNameModal";

	export default {
		name: "GroupList",
		components: {EditNameModal},
		props: {
			value: Object,
		},

		computed: {
			section: function () {
				return this.form.formSchema.sections[this.form.selected.sectionIndex];
			},
		},

		watch: {
			form: {
				handler() {
					this.$emit("input", this.form);
				}
				,
				deep: true,
			},
		},

		data() {
			return {
				form: this.value,
			};
		},

		methods: {

			openRenameModal(index) {
				let currentGroupName = this.section.groups[index].name;
				this.$refs.editNameModal.openModal(currentGroupName, index);
			},

			renameGroup(event) {
				this.section.groups[event.index].name = event.name;
			},

			isSelected(index) {
				if (index === this.form.selected.groupIndex) {
					return "success";
				}
			},

			clearIndexes() {
				this.form.selected.groupIndex = null;
				this.form.selected.fieldIndex = null;
			},

			groupCanBeMovedUp(group, groupIndex) {
				return groupIndex !== 0
					&& this.groupIsNotFinal(group)
					&& !this.groupContainsConditionalField(group)
					&& !this.groupIsBelowFinalGroup(groupIndex);
			},

			groupCanBeMovedDown(group, groupIndex) {
				return this.groupIsNotLastOrOneElem(groupIndex)
					&& this.groupIsNotFinal(group)
					&& !this.groupContainsConditionalField(group)
					&& !this.groupIsOverConditionalGroup(groupIndex);
			},

			groupIsOverConditionalGroup(groupIndex) {
				return groupIndex + 1 < this.section.groups.length && this.groupContainsConditionalField(this.section.groups[groupIndex + 1]);
			},

			groupIsBelowFinalGroup(groupIndex) {
				// 2 bo grupa zawierajca pole warunkujace -> grupa finalna -> groupa finalna
				return groupIndex - 1 >= 2 && !this.groupIsNotFinal(this.section.groups[groupIndex - 1]);
			},

			groupIsNotFinal(group) {
				return group.final === false;
			},

			groupIsNotLastOrOneElem(index) {
				return (this.section.groups.length > 0 && index !== this.section.groups.length - 1);
			},

			groupCanBeRemoved(group) {
				return !group.final;
			},

			groupContainsConditionalField(group) {
				let field = group.fields.find(field => {
					return field.business === fieldTypes.CONDITIONAL;
				});
				if (field !== null && field !== undefined) {
					return true;
				}
				return false;
			},

			moveGroupUp(index) {
				this.swapTwoArrayElements(this.section.groups, index - 1, index);
				this.clearIndexes();
			},

			moveGroupDown(index) {
				this.swapTwoArrayElements(this.section.groups, index + 1, index);
				this.clearIndexes();
			},

			selectGroup(index) {
				this.form.selected.groupIndex = index;
				this.$forceUpdate();
			},

			removeGroup(index) {
				if (this.groupContainsConditionalField(this.section.groups[index])) {
					this.section.groups.splice(index, 3);
				} else {
					this.section.groups.splice(index, 1);
				}
				this.clearIndexes();
			},

			swapTwoArrayElements(array, index1, index2) {
				// swap na dwóch elementach tablicy w ES6
				array = [array[index1], array[index2]] = [array[index2], array[index1]];
				this.$forceUpdate();
			},
		},
	};
</script>

<style scoped>

</style>
